import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import AbstractCommand from "../../../core/application/AbstractCommand";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";
import InternalStakeholderInteractionEvent from "../event/InternalStakeholderInteractionEvent";
import InternalStakeholdersModel from "../model/InternalStakeholdersModel";

export default class RequestConversationInternalStakeholderCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {InternalStakeholdersModel} internalStakeholdersModel 
     */
    constructor(dispatcher, internalStakeholdersModel, scenarioPlayer) {
        super(dispatcher);

        this._internalStakeholdersModel = internalStakeholdersModel;
        this._scenarioPlayer = scenarioPlayer;
    }

    execute(evt) {
        /** @type {InternalStakeholderInteractionEvent} */
        const data = evt.params.data;
        const internalStakeholder = data.internalStakeholder;

        const currentInternalStakeholderContent = this._internalStakeholdersModel.getContentForInternalStakeholderId(internalStakeholder.id);
        if (!currentInternalStakeholderContent) {
            console.error(`[RequestConversationInternalStakeholderCommand] No content available for internal stakeholder.`);
            return;
        }

        this._pushContent(currentInternalStakeholderContent, this._scenarioPlayer);
    }

    _pushContent(content, contentPlayer) {
        switch (content.getType()) {
            case ContentTypes.TYPE_DIALOG:
                const playDialogEvent = new ScenarioPlayerEvent(ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE, content, contentPlayer);
                this.dispatch(playDialogEvent.type, { data: playDialogEvent });
                break;
            case ContentTypes.TYPE_MEETING_NOTES:
                const playConversationStatementEvent = new ScenarioPlayerEvent(ScenarioPlayerEvent.PUSH_CONVERSATION_STATEMENT_AVAILABLE, content, contentPlayer);
                this.dispatch(playConversationStatementEvent.type, { data: playConversationStatementEvent });
                break;

            default:
                break;
        }
    }
}